import { useEffect, useState } from 'react';
import { useBsoiGet } from 'scbk-services/http';
import { serverTime } from '../server-time';

type ServerTimeResponse = {
    serverTime: number;
};

/**
 * 서버시간을 가져오는 hook 함수
 */
const useServerTime = (url: string = '/getServerTime') => {
    const [initialized, setInitialized] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);

    const { data } = useBsoiGet<ServerTimeResponse>(
        { endpoint: url },
        { enabled: true, staleTime: 0 },
    );

    useEffect(() => {
        if (!data) {
            return;
        }

        try {
            const res = data;
            if (!res) {
                throw new Error('Server Time fetch failed');
            }

            const time = res.serverTime;

            serverTime.init(time, Date.now());

            setInitialized(true);
        } catch (e) {
            console.log('Server Time init failed, fallback to local time', e);
            serverTime.init(Date.now(), Date.now());

            setError(e as Error);
            setInitialized(false);
        }
    }, [data]);

    return {
        initialized,
        error,
    };
};

export { useServerTime };
